import React from 'react'
import { Bar } from 'react-chartjs-2'

const VerticalBarGraph = (props) => {
    let { title, x, y, secondTitle, a, width, height } = props

    const dataSets = {
        labels: x,
        datasets: [
            {
                label: title,
                fill: false,
                lineTension: 0.1,
                backgroundColor:'#7491aa',
                borderColor: 'rgba(75,192,192,1)',
                borderCapStyle: 'butt',
                borderDash: [],
                borderDashOffset: 0.0,
                borderJoinStyle: 'miter',
                pointBorderColor: 'rgba(75,192,192,1)',
                pointBackgroundColor: '#fff',
                pointBorderWidth: 1,
                pointHoverRadius: 5,
                pointHoverBackgroundColor: 'rgba(75,192,192,1)',
                pointHoverBorderColor: 'rgba(220,220,220,1)',
                pointHoverBorderWidth: 2,
                pointRadius: 5,
                pointHitRadius: 10,
                data: y,
                datalabels: {
                    display: true,
                    color: 'black',
                    anchor: 'end',
                    align: 'top',
                    font: {
                        weight: 'bold',
                        size: 12,
                    }
                }
            },
            {
                label: secondTitle,
                fill: false,
                lineTension: 0.1,
                backgroundColor:'#ecd7b2',
                borderColor: 'rgba(75,192,192,1)',
                borderJoinStyle: 'miter',
                pointBorderColor: 'rgba(75,192,192,1)',
                pointBackgroundColor: '#fff',
                pointBorderWidth: 3,
                pointHoverRadius: 5,
                pointHoverBackgroundColor: 'rgba(75,192,192,1)',
                pointHoverBorderColor: 'rgba(220,220,220,1)',
                pointHoverBorderWidth: 2,
                data: a,
                datalabels: {
                    display: true,
                    color: 'black',
                    anchor: 'end',
                    align: 'top',
                    font: {
                        weight: 'bold',
                        size: 12,
                    }
                }
            }
        ]
    };

    var options = {
        scales: {
            yAxes: [{
                stacked: false,
                ticks: {
                    beginAtZero: true,
                    min: 0,
                },
            }]
        },
        legend: {
            position: 'right',
            display: true,
            labels: {
                boxWidth: 20,
                fontColor: 'black',
                display:'flex'
            }
        },
        layout:{
            padding:{
                top:25
            }
        },
        responsive: true
    };

    return (
        <Bar width={width}
            height={height}
            data={dataSets}
            options={options}
        />
    )

}
export default VerticalBarGraph